/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Field, ErrorMessage, FieldArray } from 'formik'
import { AccountType } from '../../../models/IntentReportConfiguration'
import { Alert, Button } from 'react-bootstrap'

const Step6: FC<any> = ({ type, values }) => {
  return (
    <div className='w-xl-600px'>
      <h3 className='fv-row mt-15 mb-10'>Looker</h3>
      <div className='fv-row mb-10'>
        <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
          <span>Looker client id</span>
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Specify your looker client id'
          ></i>
        </label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='lookerClientId'
          placeholder=''
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='lookerClientId' />
        </div>
      </div>

      <h3 className='fv-row mt-15 mb-10'>Bombora configuration</h3>

      <FieldArray name='intentReportConfigurations'>
        {({ remove, push }) => (
          <div>
            {values?.intentReportConfigurations?.map((field: any, index: number) => {
              return (
                <div className='d-flex  mt-5'>
                  <div className='fv-row me-10 flex-fill'>
                    <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                      <span>Report id</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Specify your report guid'
                      ></i>
                    </label>

                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name={`intentReportConfigurations.${index}.reportId`}
                      placeholder=''
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name={`intentReportConfigurations.${index}.reportId`} />
                    </div>
                  </div>

                  <div className='fv-row me-10 '>
                    <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                      <span>Select Account Type</span>
                    </label>

                    <Field
                      as='select'
                      className='form-control form-control-lg form-control-solid'
                      name={`intentReportConfigurations.${index}.accountType`}
                      placeholder=''
                    >
                      <option value=''> Select one</option>
                      <option value={AccountType.NetNew}>{AccountType.NetNew}</option>
                      <option value={AccountType.TargetAccount}>{AccountType.TargetAccount}</option>
                    </Field>
                    <div className='text-danger mt-2'>
                      <ErrorMessage name={`intentReportConfigurations.${index}.accountType`} />
                    </div>
                  </div>

                  <div className='fv-row d-flex align-items-center'>
                    <Button variant='danger' size='sm' onClick={() => remove(index)}>
                      {' '}
                      X{' '}
                    </Button>
                  </div>
                </div>
              )
            })}

            <div className='fv-row text-danger'>
              <ErrorMessage
                name={`intentReportConfigurations`}
                render={(message) => typeof message !== 'object' && <>{message}</>}
              />
            </div>
            {values.lookerClientId ? (
              <div className='fv-row my-10'>
                <Button onClick={() => push({ reportId: undefined, accountType: undefined })}>
                  {' '}
                  Add
                </Button>
              </div>
            ) : (
              <Alert variant='primary'>
                Looker client id has to be set to add bombora configuration
              </Alert>
            )}
          </div>
        )}
      </FieldArray>
    </div>
  )
}

export { Step6 }
